import { ShieldCheck } from "lucide-react";
import { useState } from "react";
import { AUTH_STEPS, AuthFlow, type AuthStep } from "@/components/auth-flow";
import { Dialog, DialogContent } from "@/components/ui/overlay";
import { useDesktopUi } from "./ui";

/**
 * "Entrar" do app desktop (não há tela de login): diálogo sobre o editor, uma caixa por etapa.
 * Ao entrar, os projetos do espaço de convidado passam para a conta e a janela recarrega já com ela.
 */
export function LoginDialog() {
  const reason = useDesktopUi((s) => s.login);
  const set = useDesktopUi((s) => s.set);
  const [step, setStep] = useState<AuthStep>("choose");
  const meta = AUTH_STEPS[step];
  const close = () => {
    set({ login: null });
    setStep("choose");
  };
  return (
    <Dialog open={reason !== null} onOpenChange={(open) => !open && close()}>
      {reason !== null ? (
        <DialogContent
          title={meta.title}
          description={step === "choose" && reason ? reason : meta.description}
          className="max-w-[420px]"
        >
          <AuthFlow
            step={step}
            onStep={setStep}
            next="/projects"
            onDone={() => {
              close();
              // Recarrega com a identidade nova (salas de colaboração, chat e plugins), na tela de
              // projetos — entrar na conta nunca cai direto no editor.
              window.location.assign("/projects");
            }}
          />
          {step === "choose" ? (
            <div className="mt-4 flex items-start gap-2 rounded-lg border border-border bg-bg-subtle px-3 py-2.5 text-[12px] leading-relaxed text-fg-muted">
              <ShieldCheck className="mt-0.5 h-3.5 w-3.5 shrink-0" />
              Nada se perde: os projetos que você criou sem conta vão junto para a sua conta.
            </div>
          ) : null}
        </DialogContent>
      ) : null}
    </Dialog>
  );
}
